webpackJsonp([221384710756650],{

/***/ 1329:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Code Fellows","slug":"blog/author/code-fellows","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/code-fellows"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-code-fellows-0367feba22adf58f6135.js